import { render, staticRenderFns } from "./goodsGroupListbackend.vue?vue&type=template&id=6090a782&scoped=true&"
import script from "./goodsGroupListbackend.vue?vue&type=script&lang=js&"
export * from "./goodsGroupListbackend.vue?vue&type=script&lang=js&"
import style0 from "./goodsGroupListbackend.vue?vue&type=style&index=0&id=6090a782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6090a782",
  null
  
)

component.options.__file = "goodsGroupListbackend.vue"
export default component.exports